import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Table } from "react-bootstrap";
import { Pencil } from "react-bootstrap-icons";
import { CellActions } from "../../../common/cell-actions/cell-actions";
import { Loading } from "../../../common/loading/loading";

export const OnSiteServiceWorksheetTable = ({
  rowNumberInit,
  serviceWorksheets,
  hasError,
  handleSelected,
}) => {
  const intl = useIntl();

  const TableBody = ({ serviceWorksheets, rowNumberInit }) => {
    if (serviceWorksheets.length === 0) {
      return (
        <tr>
          <td colSpan={6}>
            <span className="text-danger">
              <b>
                <FormattedMessage id="data.serviceworksheet.warning.notfoundserviceworksheet" />
              </b>
            </span>
          </td>
        </tr>
      );
    }

    return serviceWorksheets.map((serviceWorksheet, index) => {
      const buttons = [];
      if (serviceWorksheet.status === "PROCESSED") {
        buttons.push({
          variant: "secondary",
          title: intl.formatMessage({
            id: "page.serviceworksheets.button.editserviceworksheets",
          }),
          icon: <Pencil />,
          action: () => {
            handleSelected(serviceWorksheet.id);
          },
        });
      }

      return (
        <tr key={serviceWorksheet.id}>
          <td className="col-rownumber">{rowNumberInit + index + 1}.</td>
          <td className="col-customer">
            {serviceWorksheet.customer?.name
              ? serviceWorksheet.customer?.name
              : "-"}
          </td>
          <td className="col-createdTime">{serviceWorksheet.createdTime}</td>
          <td className="col-user">{serviceWorksheet.user.name}</td>
          <td className="col-status">
            <FormattedMessage
              id={`data.onsiteserviceworksheet.data.status.value.${serviceWorksheet.status}`}
            />
          </td>
          <td className="col-actions">
            <CellActions buttons={buttons} />
          </td>
        </tr>
      );
    });
  };

  const LoadingBody = ({ hasError }) => (
    <tr>
      <td colSpan={6}>
        {hasError ? (
          <span className="text-danger">
            <FormattedMessage id="data.serviceworksheet.exception.listServiceWorksheet" />
          </span>
        ) : (
          <Loading />
        )}
      </td>
    </tr>
  );

  return (
    <div className="serviceworksheet-table-component table-responsive">
      <Table striped bordered>
        <thead>
          <tr>
            <th className="col-rownumber">#</th>
            <th className="col-customer">
              <FormattedMessage id="data.onsiteserviceworksheet.data.customer" />
            </th>
            <th className="col-createdTime">
              <FormattedMessage id="data.onsiteserviceworksheet.data.createdTime" />
            </th>
            <th className="col-user">
              <FormattedMessage id="data.onsiteserviceworksheet.data.user" />
            </th>
            <th className="col-status">
              <FormattedMessage id="data.onsiteserviceworksheet.data.status.label" />
            </th>
            <th className="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          {serviceWorksheets ? (
            <TableBody
              serviceWorksheets={serviceWorksheets}
              rowNumberInit={rowNumberInit}
            />
          ) : (
            <LoadingBody hasError={hasError} />
          )}
        </tbody>
      </Table>
    </div>
  );
};

OnSiteServiceWorksheetTable.propTypes = {
  rowNumberInit: PropTypes.number.isRequired,
  serviceWorksheets: PropTypes.array,
  hasError: PropTypes.bool.isRequired,
  handleSelected: PropTypes.func.isRequired,
};
